import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [verPassword, setVerPassword] = useState(false);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [modoReset, setModoReset] = useState(false);
  const [mensajeReset, setMensajeReset] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Email o contraseña incorrectos');
      setCargando(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Introduce tu email para recuperar la contraseña');
      return;
    }
    setCargando(true);
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setMensajeReset('Te hemos enviado un email para restablecer tu contraseña');
      setCargando(false);
    } catch (err) {
      setError('No encontramos ese email en el sistema');
      setCargando(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoArea}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="20" stroke="#7B6FE8" strokeWidth="2.5"
              strokeLinecap="round" strokeDasharray="100 16"
              strokeDashoffset="8" />
            <line x1="24" y1="14" x2="24" y2="34" stroke="#7B6FE8" strokeWidth="2.5" strokeLinecap="round"/>
            <line x1="14" y1="24" x2="34" y2="24" stroke="#7B6FE8" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
          <span style={styles.logoText}>METRON</span>
        </div>

        <p style={styles.subtitulo}>La medida justa de tu negocio</p>

        {!modoReset ? (
          <>
            <form onSubmit={handleLogin} style={styles.form}>
              <div style={styles.campo}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={styles.input}
                  placeholder="tu@email.com"
                  required
                />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Contraseña</label>
                <div style={styles.inputWrapper}>
                  <input
                    type={verPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    style={styles.inputConOjo}
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setVerPassword(!verPassword)}
                    style={styles.ojoBtn}
                    tabIndex={-1}
                  >
                    {verPassword ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#AFA9EC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#AFA9EC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              {error && <p style={styles.error}>{error}</p>}
              <button type="submit" style={styles.boton} disabled={cargando}>
                {cargando ? 'Entrando...' : 'Entrar'}
              </button>
            </form>
            <button
              onClick={() => { setModoReset(true); setError(''); }}
              style={styles.linkReset}
            >
              Olvidé mi contraseña
            </button>
          </>
        ) : (
          <>
            <p style={styles.textoReset}>
              Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.
            </p>
            <form onSubmit={handleReset} style={styles.form}>
              <div style={styles.campo}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={styles.input}
                  placeholder="tu@email.com"
                  required
                />
              </div>
              {error && <p style={styles.error}>{error}</p>}
              {mensajeReset && <p style={styles.exito}>{mensajeReset}</p>}
              <button type="submit" style={styles.boton} disabled={cargando}>
                {cargando ? 'Enviando...' : 'Enviar enlace'}
              </button>
            </form>
            <button
              onClick={() => { setModoReset(false); setError(''); setMensajeReset(''); }}
              style={styles.linkReset}
            >
              ← Volver al login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0e0b24',
    padding: '20px',
  },
  card: {
    background: '#1a1440',
    borderRadius: '16px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 24px 48px rgba(0,0,0,0.4)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '8px',
  },
  logoText: {
    fontSize: '1.6rem',
    fontWeight: '300',
    letterSpacing: '0.14em',
    color: '#ffffff',
    fontFamily: 'DM Sans, sans-serif',
  },
  subtitulo: {
    color: '#AFA9EC',
    fontSize: '0.85rem',
    marginBottom: '36px',
    textAlign: 'center',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  campo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: '100%',
  },
  label: {
    color: '#AFA9EC',
    fontSize: '0.8rem',
    fontWeight: '500',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  input: {
    background: '#0e0b24',
    border: '1px solid #534AB7',
    borderRadius: '8px',
    padding: '12px 16px',
    color: '#ffffff',
    fontSize: '0.95rem',
    width: '100%',
    outline: 'none',
  },
  inputWrapper: {
    position: 'relative',
    width: '100%',
  },
  inputConOjo: {
    background: '#0e0b24',
    border: '1px solid #534AB7',
    borderRadius: '8px',
    padding: '12px 44px 12px 16px',
    color: '#ffffff',
    fontSize: '0.95rem',
    width: '100%',
    outline: 'none',
  },
  ojoBtn: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    color: '#D85A30',
    fontSize: '0.85rem',
    textAlign: 'center',
  },
  exito: {
    color: '#1D9E75',
    fontSize: '0.85rem',
    textAlign: 'center',
  },
  boton: {
    background: '#534AB7',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '14px',
    fontSize: '0.95rem',
    fontWeight: '500',
    width: '100%',
    marginTop: '8px',
    cursor: 'pointer',
  },
  linkReset: {
    background: 'none',
    border: 'none',
    color: '#7B6FE8',
    fontSize: '0.85rem',
    marginTop: '20px',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  textoReset: {
    color: '#AFA9EC',
    fontSize: '0.85rem',
    textAlign: 'center',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
};

export default Login;